
export const formatNumber = (number?: number): string | undefined => number?.toLocaleString('nl-NL');
